import { useState, useCallback } from 'react'

/**
 * Drop-in useState replacement that syncs to localStorage.
 * Safe in private browsing (silent try/catch).
 * Supports updater functions identical to setState.
 */
export function usePersistentState(key, defaultVal) {
    const [state, setStateRaw] = useState(() => {
        try {
            const stored = localStorage.getItem(key)
            return stored !== null ? JSON.parse(stored) : defaultVal
        } catch {
            return defaultVal
        }
    })

    const setState = useCallback((val) => {
        setStateRaw(prev => {
            const next = typeof val === 'function' ? val(prev) : val
            try { localStorage.setItem(key, JSON.stringify(next)) } catch {}
            return next
        })
    }, [key])

    return [state, setState]
}
